import React from 'react';

import { MainTablePage } from '../../components/MainTablePage';

import { RecruitmentsSearchForm } from './RecruitmentsSearchForm';
import { useDeleteRecruitmentFilter } from './useDeleteRecruitmentFilter';
import { useGetRecruitmentsFilters } from './useGetReruitmentsFilters';
import { useRecruitmentsTableColumnDefinitions } from './useRecruitmentsTableColumnDefinitions';
import { useRecruitmentsTableDataSource } from './useRecruitmentsTableDataSource';
import { useSaveRecruitmentFilter } from './useSaveRecruitmentFilter';
import { useSearchRecruitments } from './useSearchRecruitments';
import { useUpdateRecruitmentFilter } from './useUpdateRecruitmentFilter';

export const RecruitmentsPage = () => (
  <MainTablePage
    getFilters={useGetRecruitmentsFilters}
    saveFilter={useSaveRecruitmentFilter}
    updateFilter={useUpdateRecruitmentFilter}
    deleteFilter={useDeleteRecruitmentFilter}
    getColumnsDefinition={useRecruitmentsTableColumnDefinitions}
    search={useSearchRecruitments}
    getDataSource={useRecruitmentsTableDataSource}
    storedFilterName="recruitmentsFilter"
    storedPagingData="recruitmentsPaging"
    title="Recruitments"
    searchForm={RecruitmentsSearchForm}
  />
);
